module.exports = __webpack_public_path__ + "static/media/city.7bb74568.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/code-images/city.png
// module id = 101
// module chunks = 0